/**
 * AgeVerificationService — Vérification d'âge pour le Try-On « On you »
 * ───────────────────────────────────────────────────────────────────────────
 * Apple Guideline 1.1 (rejet 2026-06-11) : le Try-On sur photo personnelle est
 * réservé aux 18+. La date de naissance est déjà collectée à l'onboarding
 * (étape 2/4, âge min 15). Ici on calcule l'âge et on bloque < 18 ans.
 */
import { getCachedUser, getCachedUserAge } from './UserContextService';

export const MIN_AGE_PERSONAL_TRYON = 18;

/** Calcule l'âge (années entières) depuis une date ISO/Date. null si invalide. */
export function computeAge(birthDate) {
  if (!birthDate) return null;
  const d = new Date(birthDate);
  if (isNaN(d.getTime())) return null;
  const now = new Date();
  let age = now.getFullYear() - d.getFullYear();
  const m = now.getMonth() - d.getMonth();
  if (m < 0 || (m === 0 && now.getDate() < d.getDate())) age -= 1;
  return age;
}

/** Âge de l'utilisateur courant (cache synchrone). null si inconnu. */
export function getUserAge() {
  try {
    const cached = typeof getCachedUserAge === 'function' ? getCachedUserAge() : null;
    if (typeof cached === 'number' && cached > 0) return cached;
  } catch (_) {}
  const u = (typeof getCachedUser === 'function' ? getCachedUser() : null) || {};
  return computeAge(u.birthDate || u.birth_date);
}

/**
 * L'utilisateur est-il autorisé au Try-On « On you » (18+) ?
 * - âge connu ≥ 18  → true
 * - âge connu < 18  → false (BLOQUÉ)
 * - âge inconnu     → true (profil incomplet ; le consentement 3 étapes
 *                     « j'ai 18 ans ou plus » couvre alors le cas)
 */
export function isAdultForPersonalTryOn() {
  const age = getUserAge();
  if (age == null) return true;
  return age >= MIN_AGE_PERSONAL_TRYON;
}

export default { MIN_AGE_PERSONAL_TRYON, computeAge, getUserAge, isAdultForPersonalTryOn };
